// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LD-z","hovered":"MD-z","hoverImage":"ND-z","mainImage":"OD-z","imageNoBackground":"PD-z","fullSizeImage":"QD-z"};